import { memo, useMemo } from "react";
import Html from "react-pdf-html";

import {
  DEFAULT_PDF_CSS_STYLE,
  normalizePrintableHtml
} from "components/pdf-generation-v3/pdf-generation-v3.utils";

type PdfDocumentHtmlProps = {
  bodyHtml?: string | null;
};

// Pre-compute static wrapper parts for better performance
const STATIC_WRAPPER_START = `<html><body><style>${DEFAULT_PDF_CSS_STYLE}</style>`;
const STATIC_WRAPPER_END = `</body></html>`;

function PdfDocumentHtmlSimple({ bodyHtml }: PdfDocumentHtmlProps) {
  const content = useMemo(() => {
    if (!bodyHtml) return "";

    const normalized = normalizePrintableHtml(bodyHtml);
    return `${STATIC_WRAPPER_START}${normalized}${STATIC_WRAPPER_END}`;
  }, [bodyHtml]);

  return <Html>{content}</Html>;
}

// Memoize component to prevent unnecessary re-renders
export default memo(PdfDocumentHtmlSimple);
